import get from 'transmute/get';
export const getLanguage = get('language');
export const getSearchableKnowledgeBaseIds = get('searchableKnowledgeBaseIds');
export const getGates = get('gates');
export const getEnableSdkCloseButton = get('enableSdkCloseButton');
export const getRecommendedQuestionsForAgent = get('recommendedQuestionsForAgent');